module.exports = __webpack_public_path__ + "img/TZS09670.fa82f027.jpeg";